
import { useState } from 'react';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d4skl9pjcbkn8g06lt2g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email }).toString(),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setSubmitMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setSubmitMessage('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-32 bg-[#1a2332]">
      <div className="max-w-7xl mx-auto px-20">
        {/* Title Area */}
        <div className="mb-16">
          <p className="text-xs font-semibold tracking-widest text-blue-500 uppercase mb-4">
            GET IN TOUCH
          </p>
          <h2 className="text-5xl font-bold text-white tracking-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            LET'S CONNECT
          </h2>
        </div>

        {/* Contact Information Grid */}
        <div className="grid grid-cols-4 gap-12 pb-20 border-b border-gray-700">
          {/* Column 1 - Company Info */}
          <div className="border-r border-gray-700 pr-8">
            <h3 className="text-base font-semibold text-white mb-4">EL DORADO S.R.L.</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Pasaje Guayaquil 85<br />
              Río Grande<br />
              Argentina
            </p>
          </div>

          {/* Column 2 - Email Subscription */}
          <div>
            <p className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-4">
              STAY UPDATED
            </p>
            <form id="newsletter-form" data-readdy-form onSubmit={handleSubscribe} className="relative">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                disabled={isSubmitting}
                className="w-full bg-transparent border-b border-gray-600 text-sm text-white placeholder-gray-500 py-3 pr-10 focus:outline-none focus:border-blue-500 transition-colors"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-400 hover:text-blue-500 transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </form>
            {submitMessage && (
              <p className={`text-xs mt-2 ${submitMessage.includes('Thank') ? 'text-green-400' : 'text-red-400'}`}>
                {submitMessage}
              </p>
            )}
            <p className="text-xs text-gray-500 mt-3">
              We respect your <span className="underline cursor-pointer hover:text-gray-300">privacy</span>
            </p>
          </div>

          {/* Column 3 - Quick Links */}
          <div>
            <p className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-4">
              NAVIGATION
            </p>
            <div className="flex flex-col gap-5">
              <button
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                className="text-sm text-white hover:text-blue-500 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                About Us
              </button>
              <button
                onClick={() => document.getElementById('vpn-services')?.scrollIntoView({ behavior: 'smooth' })}
                className="text-sm text-white hover:text-blue-500 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                VPN Services
              </button>
              <button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="text-sm text-white hover:text-blue-500 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
            </div>
          </div>

          {/* Column 4 - Contact Details */}
          <div>
            <p className="text-xs font-semibold tracking-widest text-gray-400 uppercase mb-4">
              REACH US
            </p>
            <div className="flex flex-col gap-5">
              <a
                href="mailto:info@eldoradosrx.com"
                className="text-sm text-white hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                info@eldoradosrx.com
              </a>
              <a
                href="tel:+15677722383"
                className="text-sm text-white hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                +1 567 772 2383
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Brand Typography */}
        <div className="mt-20 text-center">
          <h3 className="text-9xl font-bold text-[#f5f1e8]/40 tracking-tighter" style={{ fontFamily: 'Poppins, sans-serif', letterSpacing: '-0.05em' }}>
            ELDORADO
          </h3>
        </div>
      </div>
    </section>
  );
}
